import React from 'react'

export default class OOBAErrorModal extends React.Component {
    render() {
        const {handleClose} = this.props;
        return (
            <div className="cb-modal cb-fade" id="oobaErrorModal" onClick={() => {
                if(handleClose)
                    handleClose()
                }}>
                <div className="cb-modal-dialog" role="document">
                    <div className="cb-modal-content" onClick={(e) => { e.stopPropagation() }}>
                        <div className="cb-modal-header">
                            <h2 className="cb-modal-title">Processing Error</h2>
                        </div>
                        <div className="cb-modal-body">
                            <p>There was an error while processing your request.  Please contact Commercial Customer Support at 800-207-0886.</p>
                        </div>
                        <div className="cb-modal-footer">
                            <button type="button" className="cb-btn cb-btn-primary" data-dismiss="cb-modal" onClick={() => {
                                if(handleClose)
                                    handleClose()
                            }}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

